export const PaymentMPProductSKU = {
  PDA: 'PDA_POSTULANTE',
  NULINGA: 'NULINGA',
  MIGURU: 'ANALISIS_CV_LABLAB',
  DOCTORCV: 'ANALISIS_CV_DR_CV',
}
